<template>
  <div>
    <CRow>
      <CCol sm="12">
        <AssetPersonsTable
          :items="asset_persons"
          hover
          striped
          border
          small
          fixed
          caption="Personas"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import AssetPersonsTable from '../../components/asset_persons/AssetPersonsTable.vue'
import ws from '../../services/asset_persons';
import store from '../../store'

export default {
  name: 'AssetPersons',
  components: { AssetPersonsTable },
  data: function () {
		return {
            asset_persons: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.asset_persons = response.data;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.asset_persons = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
